var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircularArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_666_2065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8625 13.8625C13.675 16.05 12.1 18.6125 11.1375 21.3375L3.6 18.675C4.95 14.8375 7.15 11.25 10.2 8.20001C21.1375 -2.73749 38.8625 -2.73749 49.8 8.20001L57 1.00001L60 4.00001V24H40L37 21L44.1375 13.8625C36.325 6.05001 23.6625 6.05001 15.85 13.8625H15.8625ZM15.8625 42.15C23.675 49.9625 36.3375 49.9625 44.15 42.15C46.3375 39.9625 47.9125 37.4 48.875 34.675L56.425 37.3375C55.075 41.1625 52.875 44.75 49.8125 47.8125C38.875 58.75 21.15 58.75 10.225 47.8125L3 55L0 52V32H20L23 35L15.8625 42.1375V42.15Z",
    fill: "url(#paint0_linear_666_2065)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_666_2065",
    x: 0,
    y: -0.00311279,
    width: 60,
    height: 57.6339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61516
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.807578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_666_2065"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_2065",
    x1: 52.6094,
    y1: 67.9935,
    x2: -4.48245,
    y2: 57.7458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E8E3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E3DE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircularArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CircularArrow.08c5277d.svg";
export { ForwardRef as ReactComponent };